var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgIconCar = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 19,
  height: 16,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M3.625 9.125H6.25M1 5.625l1.75.875 1.112-3.335c.23-.689.344-1.033.557-1.288a1.75 1.75 0 0 1 .702-.506c.309-.121.671-.121 1.397-.121h6.464c.726 0 1.088 0 1.397.121.273.108.514.282.702.506.213.255.328.6.557 1.288L16.75 6.5l1.75-.875m-5.25 3.5h2.625M5.2 6.5h9.1c1.47 0 2.205 0 2.767.286.494.252.895.653 1.147 1.147.286.562.286 1.297.286 2.767v2.363c0 .406 0 .61-.034.778a1.75 1.75 0 0 1-1.375 1.375c-.169.034-.372.034-.779.034h-.437a1.75 1.75 0 0 1-1.75-1.75.438.438 0 0 0-.438-.438H5.814a.438.438 0 0 0-.438.438 1.75 1.75 0 0 1-1.75 1.75h-.438c-.406 0-.61 0-.778-.034a1.75 1.75 0 0 1-1.375-1.375C1 13.672 1 13.47 1 13.063V10.7c0-1.47 0-2.205.286-2.767a2.625 2.625 0 0 1 1.147-1.147C2.995 6.5 3.73 6.5 5.2 6.5Z",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));

export default SvgIconCar;